<ol class="breadcrumb">
  <li class="breadcrumb-item">
    <a [routerLink]="['Submissions']">
      Submissions
    </a>
  </li>
</ol>
<div *ngIf="userInfo">
<table aria-describedby="Submission Table" class="submission-table table-striped table-hover">
    <thead>
    <tr>
        <th scope="col" class="notes-header">Notes</th>
        <th scope="col" class="resolution-header">Resolved</th>
        <th scope="col" class="tc-review-header">Reviewed</th>
        <th scope="col" class="hmlid-header">HML ID</th>
        <th scope="col" class="sample-errors-header">Sample / Errors</th>
        <th scope="col" class="submission-status-header">Status</th>
        <th scope="col" class="received-header">Received (CST)</th>
        <th scope="col" class="project-name-header">Project Name</th>
        <th scope="col" class="reporting-center-header">Reporting Center</th>
        <th scope="col" class="gene-family-header">Gene Family</th>
        <th scope="col" class="uploader-file-name-header">Uploader File Name</th>
        <th scope="col" class="uuid-header">UUID</th>
    </tr>
    </thead>
    <tbody id="dashboardScrollPane">
    <tr *ngFor="let submission of activeFileRecordList">
        <td class="resolution-cell-1">
            <mat-icon class="icon" (click)="openNote( submission)">insert_comment</mat-icon>
            <span id="{{ 'badge'+ submission.uuid }}" class="badge" [hidden]="!submission.notes">{{badgeCount}}</span>
        </td>
        <td class="resolution-cell-2">
            <mat-checkbox color="primary" [checked]="submission.resolution"
                          (change)="resolve($event.checked,submission.uuid)"></mat-checkbox>
        </td>
        <td class="tc-review-cell">
            <mat-checkbox type="checkbox" [checked]="submission.tcReview"
                          (change)="review($event.checked,submission.uuid)" color="primary">
            </mat-checkbox>
        </td>
        <td class="hmlid-cell">
            <mat-icon matTooltip="FHIR Sample Data Available" *ngIf="submission.fhirInd" svgIcon="fhir" class="material-icons--outline icon fhir"></mat-icon>
            <mat-icon class="material-icons--outline icon corrections" *ngIf="submission.correctionInd">create
            </mat-icon>
            <span matTooltip={{submission.hmlId}} (click)="displaySourceDialog(submission.uuid, submission.hmlId, submission.uploaderFileName, submission.status)">{{submission.hmlId}}</span>
        </td>
        <td class="sample-errors-cell">
            <a [routerLink]="['submission',submission.uuid]">
                <div class="status-button"><span class="sample-count">{{submission.sampleCount}}</span> / <span
                    class="error-count">{{submission.errorCount>0? submission.errorCount : '-'}}</span></div>
            </a>
        </td>
        <td *ngIf="submission.status === 'Success' || (!userInfo.internalUser && submission.status != 'Failed') ; else showErrorIcon" class="submission-status-cell">
            <div class="submission-status">{{submission.status}}</div>
        </td>

        <ng-template #showErrorIcon>
            <td class="submission-status-cell">

              <mat-icon matTooltip="Click to view error information." class="icon info" [hidden]="!submission.status" (click)="displayErrorDialog(submission.uuid)">error_outline</mat-icon>
              <div class="submission-status">{{submission.status}}</div>
            </td>
        </ng-template>

        <td class="received-cell">{{submission.receivedDate}}</td>
        <td matTooltip={{submission.projectName}} class="project-name-cell">{{submission.projectName}}</td>
        <td class="reporting-center-cell">{{submission.reportingCenter}}</td>

        <div *ngIf="submission.geneFamily==='Blood Group Antigens'; then thenBlock else elseBlock"></div>
            <ng-template #thenBlock><td class="gene-family-cell" >BGA</td></ng-template>
            <ng-template #elseBlock><td class="gene-family-cell" >{{submission.geneFamily}}</td></ng-template>

        <td matTooltip={{submission.uploaderFileName}} class="uploader-file-name-cell">{{submission.uploaderFileName}}</td>
        <td class="uuid-cell">
            <mat-icon matTooltip="Copy UUID" class="icon copy rotate" (click)="copyMessage($event, submission.uuid)">content_copy</mat-icon>
            <div matTooltip={{submission.uuid}} class="uuid">{{submission.uuid}}</div>

      </td>
    </tr>
    <p class="empty-search" *ngIf="activeFileRecordList != null && activeFileRecordList.length === 0">No results found for search criteria entered</p>
  </tbody>
</table>
<div class="table-tools">
    <div class="extract-button" #extractButton (click)="extract()">
        <em class="material-icons file-dwnld">file_download</em>Extract
    </div>
    <div class="pagination-button"><pagination></pagination></div>
</div>
</div>

<modal-component #errorDialog
    [title]="errorModalTitle"
    [data]="{
        resizeOrClose:'close',
        okBtnTitle:'',
        cancelBtnTitle: '',
        editBtnTitle: '',
        resubmitBtnTitle: '',
        footerMessage: 'Access your original file to correct errors. Submit a corrected file.'
    }">
    <table aria-describedby="Submission Error" class="no-border" id="validationErrorsTable">
        <thead>
            <tr class="error-header-row"><th scope="col" class="error-location-hdr">Error&nbsp;Location</th><th scope="col" class="error-desc-hdr">Description</th></tr>
        </thead>
        <tbody class="no-scroll">
            <tr *ngFor="let error of errorDetails" class="error-details-row">
                <td class="error-location-cell">{{error.errorLocation}}</td>
                <td class="error-desc-cell">{{error.errorDescription}}</td>
            </tr>
        </tbody>
    </table>
</modal-component>
